import React, {
  Fragment,
  useEffect,
  useState,
  useRef,
  useCallback,
} from 'react';
import GoogleMapReact from 'google-map-react';
import Marker from './Marker';
import mapStyles from './mapStyles';
import constants, { ViewMode, gmId } from '../../constants';

const DealerSinglePageContainer = ({ latitude, longitude }) => {
  const mapRef = useRef();
  const [googleMapsKey, setGoogleMapsKey] = useState(constants.gmId);
  const [zoom, setZoom] = React.useState(7);
  const [mounted, setMounted] = useState(false);

  const [mapApi, setMapApi] = useState();
  const [mapInstance, setMapInstance] = useState();
  const [mapApiLoaded, setMapApiLoaded] = useState(false);

  const [positioningEnabled, setPositioningEnabled] = useState(true);
  const [position, setPosition] = useState({
    // Default: �hlins Reseller Network, Stockholm
    lat: Number(latitude || '59.344780380234646'),
    lng: Number(longitude || '18.048064024644894'),
  });
  const [positionLocal, setPositionLocal] = useState({
    lat: 0,
    lng: 0,
  });

  const handleApiLoaded = (map, maps) => {
    setMapApiLoaded(true);
    setMapApi(map);
    setMapInstance(maps);
  };

  Array.prototype.unique = function () {
    var a = this.concat();
    for (var i = 0; i < a.length; ++i) {
      for (var j = i + 1; j < a.length; ++j) {
        if (a[i] === a[j]) a.splice(j--, 1);
      }
    }
    return a;
  };

  useEffect(() => {
    async function setup() {
      if (!mounted) {
        setZoom(10);
        setPositioningEnabled(true);
        setMounted(true);
      }
    }
    setup();
  }, []);

  return (
    <GoogleMapReact
      yesIWantToUseGoogleMapApiInternals
      bootstrapURLKeys={{
        key: googleMapsKey,
        libraries: ['places', 'geometry'],
      }}
      defaultZoom={zoom}
      zoom={zoom}
      center={position}
      // Available styles: dark, default
      options={{
        mapTypeControl: false,
        disableDefaultUI: true,
        styles: mapStyles.dark,
        maxZoom: 19,
      }}
      onChange={({ zoom, center, bounds }) => {
        setZoom(zoom);
        setPosition(center);
      }}
      onGoogleApiLoaded={({ map, maps }) => {
        handleApiLoaded(map, maps);
        mapRef.current = map;
      }}
    >
      <Marker lat={latitude} lng={longitude} name={name} isActive={true} />
    </GoogleMapReact>
  );
};
export default React.memo(DealerSinglePageContainer);
